(function ($) {
	function getSelectionRange(elem) {
		if ('selectionStart' in elem) { // W3C's DOM
			return {
				start: elem.selectionStart,
				end: elem.selectionEnd
			};
		} else if (document.selection) { // IE
			elem.focus();

			var range = document.selection.createRange(),
				content = elem.value;

			if (range === null) {
				return {
					start: 0,
					end: content.length
				};
			}

			var re = elem.createTextRange();
			var rc = re.duplicate();
			re.moveToBookmark(range.getBookmark());
			rc.setEndPoint('EndToStart', re);

			return {
				start: rc.text.length,
				end: rc.text.length + range.text.length
			};
		} else {
			return null;
		}
	}

	var masks = {
		Phone: /^(\+|\+\d|\d)(-)?(\(|\(\d+|\(\d+\)|\d+)?(-)?(\d+|\d+-||\d+-\d+)*(\d+)?$/,
		UniqueName: /^([0-9A-Za-z_.]*)$/,
		Postcode: /^\d*$/,
		Integer: /^([1-9]\d*)$/,
		Decimal: /^(([1-9]\d*([.,]\d{0,2}?)?)|(0([.,]\d{0,2})?)|([1-9]\d*))$/
	};

	$.fn.keyFilter = function (maxLength, regexp) {

		return this.each(function () {

			var $elem = $(this),
				mask = (regexp && new RegExp(regexp)) || masks[$elem.data('mask')];

			$elem.on('keypress', function (event) {
				if (event.ctrlKey || event.altKey || event.which <= 32) return;

				var selection = getSelectionRange(this),
                    firstPart = this.value.substring(0, selection.start),
                    lastPart = this.value.substring(selection.end, this.value.length);
				var newValue = firstPart + String.fromCharCode(event.which) + lastPart;
				if (mask && !mask.test(newValue) || (maxLength && maxLength < newValue.length)) {
					event.preventDefault();
				}

			})
				.on('paste', function (event) {
					var $input = $(this),
						val = $input.val();
					setTimeout(function () {
						var newValue = $input.val();
						if (mask && !mask.test(newValue) || (maxLength && maxLength < newValue.length)) {
							$input.val(val);
						}
					}, 0);
				});
		});
	};
})(jQuery);